import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';

interface RoleBasedRouteProps {
  allowedRoles: string[];
  redirectPath?: string;
}

/**
 * A component that restricts access to routes based on user roles
 * @param allowedRoles - Array of roles that are allowed to access the route
 * @param redirectPath - Path to redirect to if user doesn't have permission (defaults to /dashboard)
 */
export const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ 
  allowedRoles, 
  redirectPath = '/dashboard' 
}) => {
  const { userRole, isLoading } = useRole();
  
  // If still loading role information, don't render anything yet
  if (isLoading) {
    return null;
  }
  
  // If user doesn't have a role or their role is not in the allowed roles, redirect
  if (!userRole || !allowedRoles.includes(userRole.role)) {
    return <Navigate to={redirectPath} replace />;
  }
  
  // If user has permission, render the child routes
  return <Outlet />;
}; 